export default {
    ru: [
        {
            title: 'О выставке',
            items: [
                {
                    title: 'Общая информация',
                    link: 'pages/about',
                },
                // {
                //     title: 'Брошюра',
                //     link: '/files/rubae_presentation_2021.pdf',
                // },
                {
                    title: 'План выставки',
                    //     link: process.env.PAVILION_EXPOSITION_URL,
                    link: '/files/pavilion_exposition.pdf',
                    //     // link: 'pages/updating',
                },
                {
                    title: 'Электронный каталог',
                    link: '/files/catalog/index.html',
                },
                // {
                //     title: 'Статическая площадка',
                //     link: 'pages/static',
                // },
                {
                    title: 'Список участников',
                    link: 'pages/exhibitors-list',
                    //link: 'pages/updating',
                },
                // {
                //     title: 'Деловая программа',
                //     link: 'pages/schedule',
                // },
                {
                    title: 'Как добраться',
                    link: 'pages/location',
                },
                // {
                //     title: 'Время работы',
                //     link: 'pages/opening-hours',
                // },
            ],
        },
        {
            title: 'Участникам',
            items: [
                {
                    title: 'Бейджи участников',
                    link: '/files/Exhibitor_Badge_Request_Form.docx',
                },
                {
                    title: 'Форма для каталога',
                    link: '/files/Exhibitor_Catalog_Information_Form.docx',
                },
                // {
                //     title: 'Виды участия',
                //     // link: 'pages/exhibit-application',
                //     link: 'pages/updating',
                // },
                // {
                //     title: 'План экспозиции',
                //     link: process.env.PAVILION_EXPOSITION_URL,
                //     // link: '/files/pavilion_exposition.pdf',
                //     // link: 'pages/updating',
                // },
                // {
                //     title: 'Личный кабинет',
                //     link: 'https://lk.rubae.ru',
                {
                    title: 'Заявка на участие',
                    link: '/files/exhibit-application-ru.pdf',
                },
                {
                    title: 'Комплектация стенда',
                    // link: 'pages/updating',
                    //link: '/files/exhibit-application-ru-add.pdf',
                    link: '/files/basic-stands.pdf',
                },
                // {
                //     title: 'First time exhibitor application',
                //     link: '/files/First Time rus.pdf',
                //     //link: 'pages/updating',
                // },
                {
                    title: 'Заявка участника на статику',
                    link: '/files/static-application-ru.pdf',
                    // link: 'pages/updating',
                },
                {
                    title: 'Руководство участника',
                    link: '/files/exhibitor-manual-ru.pdf',
                    //link: 'pages/updating',
                },
                {
                    title: 'Дополнительное оборудование',
                    link: '/files/additional-equipment-ru.pdf',
                    // link: 'pages/updating',
                },
                {
                    title: 'Спонсорство и реклама',
                    //link: '/files/RUBAE_rus.pdf',
                    link: '/files/AdvertisingOpportunitiesRUBAE_RUS.pdf',
                    // link: 'pages/updating',
                },
                {
                    title: 'Генеральный спонсор',
                    // link: 'pages/broker-project',
                    link:
                        '/files/GeneralSponsorAdvertisingOpportunitiesRUBAE_RUS.pdf',
                    //link: 'pages/updating',
                },
                {
                    title: 'Деловая программа',
                    //link: 'pages/conference-program',
                    link: '/files/conference-program.pdf',
                    //link: 'pages/updating',
                },
                // {
                //     title: 'Газета Show Daily',
                //     link: '/files/ShowDaily.pdf',
                // },
                // {
                //     title: 'Визовая поддержка',
                //     link: 'pages/visa-support',
                //     // link: 'pages/updating',
                // },
                // {
                //     title: 'Услуги по уборке воздушных судов',
                //     link: 'pages/aircraft-cleaning',
                // },
                {
                    title: 'Трансфер партнер',
                    // link: 'pages/transfer-partner',
                    link: 'pages/updating',
                },
                // {
                //     title: 'Программа мероприятия',
                //     link: '/files/RUBAE2021 AGENDA_RUS_ENG.pdf',
                // },
                // {
                //     title: 'Размещение в отеле',
                //     link: 'pages/hotel-partner',
                // },
                // {
                //     title: 'Размещение в отеле',
                //     link:
                //         'http://eventsathilton.com/show/5b3cb1b81eccc8058488ee9b',
                // },
            ],
        },
        {
            title: 'Посетителям',
            items: [
                // {
                //     title: 'Регистрация',
                //     link: 'pages/registration/',
                // },
                // {
                // title: 'Купить билет',
                //link: 'pages/ticket',
                //link: 'pages/registration/',
                //     link: 'https://rubae21.ruwidgets.ru/',
                // },
                {
                    title: 'Время работы',
                    link: 'pages/opening-hours',
                },
                {
                    title: 'Как добраться',
                    link: 'pages/location',
                },
                // {
                //     title: 'Официальный каталог выставки',
                //     link: '/files/RUBAE_catalog.pdf',
                // },
                // {
                //     title: 'Новости и пресса',
                //     link: 'pages/news',
                // },
                {
                    title: 'Аккредитация СМИ',
                    link: 'pages/media-accreditation',
                    //link: '/files/Форма_аккредитации_прессы.docx',
                },
                // {
                //     title: 'Визовая поддержка',
                //     link: 'pages/visa-support',
                // },
                {
                    title: 'Трансфер партнер',
                    // link: 'pages/transfer-partner',
                    link: 'pages/updating',
                },
                // {
                //     title: 'Размещение в отеле',
                //     link: 'pages/hotel-partner',
                // },
                // {
                //     title: 'Программа мероприятия',
                //     link: '/files/RUBAE2021 AGENDA_RUS_ENG.pdf',
                // },
                // {
                //     title: 'Размещение в отеле',
                //     link:
                //         'http://eventsathilton.com/show/5b3cb1b81eccc8058488ee9b',
                // },
            ],
        },
        // {
        //     title: 'Контакты',
        //     items: [
        //         // {
        //         //     title: 'Организационный комитет',
        //         //     link: 'pages/organizing-commitee',
        //         // },
        //         {
        //             title: 'Генеральный застройщик',
        //             link: 'pages/general-contractor',
        //         },
        //         {
        //             title: 'Генеральный экспедитор',
        //             link: 'pages/freight-forwarder',
        //         },
        //         {
        //             title: 'Кейтеринг партнер',
        //             link: 'pages/catering',
        //         },
        //     ],
        // },
        {
            title: 'Фотогалерея',
            items: [
                { title: '2018', link: 'pages/gallery/2018' },
                { title: '2019', link: 'pages/gallery/2019' },
                { title: '2021', link: 'pages/gallery/2021' },
                { title: '2025', link: 'pages/gallery/2025' },
            ],
        },
        {
            title: 'Архив',
            items: [
                {
                    title: '2018',
                    link: 'https://2018.rubae.ru/ru/',
                },
                {
                    title: '2019',
                    link: 'https://2019.rubae.ru/ru/',
                },
                {
                    title: '2021',
                    link: 'https://rubae2021.netlify.app/ru/',
                },
            ],
        },
    ],

    en: [
        {
            title: 'About',
            items: [
                {
                    title: 'General information',
                    link: 'pages/about',
                },
                // {
                //     title: 'Official brochure',
                //     link: '/files/rubae_presentation_2021.pdf',
                // },
                {
                    title: 'Floor plan',
                    // link: process.env.PAVILION_EXPOSITION_URL,
                    link: '/files/pavilion_exposition_en.pdf',
                    // link: 'pages/updating',
                },
                // {
                //     title: 'Static display',
                //     link: 'pages/static',
                // },
                {
                    title: 'Exhibitors list',
                    link: 'pages/exhibitors-list',
                    //link: 'pages/updating',
                },
                // {
                //     title: 'Programe schedule',
                //     link: 'pages/schedule',
                // },
                {
                    title: 'Venue location',
                    link: 'pages/location',
                },
                // {
                //     title: 'Opening hours',
                //     link: 'pages/opening-hours',
                // },
            ],
        },
        {
            title: 'Exhibitor information',
            items: [
                // {
                //     title: 'Exhibiting costs',
                //     // link: 'pages/exhibit-application',
                //     link: 'pages/updating',
                // },
                // {
                //     title: 'Floor plan',
                //     link: process.env.PAVILION_EXPOSITION_URL,
                //     // link: '/files/pavilion_exposition.pdf',
                //     // link: 'pages/updating',
                // },
                // {
                //     title: 'Personal account',
                //     link: 'https://lk.rubae.ru',
                // },
                {
                    title: 'Exhibit application',
                    //link: '/files/exhibit-application-en.pdf',
                    link: 'pages/updating',
                },
                // {
                //     title: 'First time exhibitor application',
                //     // link: '/files/First Time 2021 eng.pdf',
                //     link: 'pages/updating',
                // },
                {
                    title: 'Static display application',
                    //link: '/files/static-application-en.pdf',
                    link: 'pages/updating',
                },
                {
                    title: 'Exhibitor manual',
                    //link: '/files/exhibitor-manual-en.pdf',
                    link: 'pages/updating',
                },
                // {
                //     title: 'Additional equipment',
                //     link: '/files/Additional equipment eng 2021.pdf',
                // },
                {
                    title: 'Marketing opportunities',
                    //link: '/files/RUBAE_eng.pdf',
                    link: 'pages/updating',
                },
                // {
                //     title: 'Broker Project',
                //     // link: 'pages/broker-project',
                //     link: 'pages/updating',
                // },
                {
                    title: 'Conference program',
                    link: 'pages/updating',
                    //link: 'pages/conference-program',
                },
                // {
                //     title: 'Show Daily newspapper',
                //     link: '/files/ShowDaily.pdf',
                // },
                // {
                //     title: 'Visa support',
                //     // link: 'pages/visa-support',
                //     link: 'pages/updating',
                // },
                // {
                //     title: 'Aircraft cleaning service',
                //     link: 'pages/aircraft-cleaning',
                // },
                {
                    title: 'Transfer partner',
                    // link: 'pages/transfer-partner',
                    link: 'pages/updating',
                },
                // {
                //     title: 'Agenda',
                //     link: '/files/RUBAE2021 AGENDA_RUS_ENG.pdf',
                // },
                // {
                //     title: 'Hotel accommodation',
                //     link: 'pages/hotel-partner',
                // },
            ],
        },
        {
            title: 'Attendee',
            items: [
                // {
                //     title: 'Registration',
                //     link: 'pages/registration/',
                // },
                // {
                //     title: 'Buy a ticket',
                //     //    link: 'pages/ticket',
                //     //link: 'pages/registration/',
                //     link: 'https://rubae21.ruwidgets.ru/en/',
                // },
                {
                    title: 'Opening hours',
                    link: 'pages/opening-hours',
                },
                {
                    title: 'Venue location',
                    link: 'pages/location',
                },
                // {
                //     title: 'Official Exhibitor catalogue',
                //     link: '/files/RUBAE_catalog.pdf',
                // },
                // {
                //     title: 'News and Press',
                //     link: 'pages/news',
                // },
                // {
                //     title: 'Media accreditation',
                //     link: 'pages/accreditation',
                // },
                {
                    title: 'Visa support',
                    link: 'pages/visa-support',
                },
                {
                    title: 'Transfer partner',
                    // link: 'pages/transfer-partner',
                    link: 'pages/updating',
                },
                // {
                //     title: 'Agenda',
                //     link: '/files/RUBAE2021 AGENDA_RUS_ENG.pdf',
                // },
                // {
                //     title: 'Hotel accommodation',
                //     link: 'pages/hotel-partner',
                // },
                // {
                //     title: 'Hotel accommodation',
                //     link:
                //         'http://eventsathilton.com/show/5b3cb1b81eccc8058488ee9b',
                // },
            ],
        },
        // {
        //     title: 'Contacts',
        //     items: [
        //         // {
        //         //     title: 'Organizing Committee',
        //         //     link: 'pages/organizing-commitee',
        //         // },
        //         {
        //             title: 'General Contractor',
        //             link: 'pages/general-contractor',
        //         },
        //         {
        //             title: 'Official freight forwarder',
        //             link: 'pages/freight-forwarder',
        //         },
        //         {
        //             title: 'Catering partner',
        //             link: 'pages/catering',
        //         },
        //     ],
        // },
        {
            title: 'Photo gallery',
            items: [
                { title: '2018', link: 'pages/gallery/2018' },
                { title: '2019', link: 'pages/gallery/2019' },
                { title: '2021', link: 'pages/gallery/2021' },
                { title: '2025', link: 'pages/gallery/2025' },
            ],
        },
        {
            title: 'Archive',
            items: [
                {
                    title: '2018',
                    link: 'https://2018.rubae.ru/en/',
                },
                {
                    title: '2019',
                    link: 'https://2019.rubae.ru/en/',
                },
                {
                    title: '2021',
                    link: 'https://rubae2021.netlify.app/en/',
                },
            ],
        },
    ],
};



// WEBPACK FOOTER //
// ./src/data/navigation.js